<template>
	<div class="job-list">
		<div class="job-list__filters">
			<FormInputSelect
				id="job-filter-brand"
				:label="$t('jobs.filter.brand')"
				v-model="filters.brand"
				:options="brandOptions"
			/>
			<FormInputSelect
				id="job-filter-canton"
				:label="$t('jobs.filter.canton')"
				v-model="filters.canton"
				:options="cantonOptions"
			/>
			<FormInputSelect
				id="job-filter-work-area"
				:label="$t('jobs.filter.workArea')"
				v-model="filters.workArea"
				:options="workAreaOptions"
			/>
		</div>

		<ul class="job-list__jobs">
			<li
				v-for="(job, index) in filteredJobs"
				:key="job.id"
				class="job-list__job"
			>
				<a
					class="job-list__job-link"
					:href="job.url"
					target="_blank"
				>
					<figure class="job-list__job-image">
						<img
							class="job-list__job-image-element"
							:src="job.image"
							width="428"
							height="428"
							:alt="job.title"
							:loading="index < 3 ? 'eager' : 'lazy'"
							:fetchpriority="index < 3 ? 'high' : null"
						>
					</figure>
					<div class="job-list__job-details">
						<span
							class="job-list__job-title"
							v-html="job.title"
						/>
						<span
							class="job-list__job-location"
							v-html="job.subtitle"
						/>
					</div>
				</a>
			</li>
			<li
				v-if="!filteredJobs.length"
				class="job-list__empty"
				v-html="$t('jobs.empty')"
			/>
		</ul>

	</div>
</template>

<script>
import { mapGetters } from "vuex"
import scrrroll from 'scrrroll'
import FormInputSelect from "@/components/FormInputSelect"
import Button from '@/components/Button'
import GeneralMessage from '@/components/GeneralMessage'

export default {
	components: {
		FormInputSelect,
		Button,
		GeneralMessage,
	},
	data() {
		return {
			filters: {
				brand: '',
				canton: '',
				region: '',
				workArea: ''
			}
		}
	},
	computed: {
		...mapGetters('jobs', [
			'jobs',
			'workAreas',
			'cantons',
			'regions',
			'brands',
		]),
		...mapGetters('loader', [
			'isLoading',
		]),
		loading: {
			set(value) {
				this.$store.dispatch('loader/setLoading', value);
				this.$emit('loading', value);
			},
			get() {
				return this.isLoading;
			}
		},
		brandOptions() {
			return [
				{
					value: '',
					label: this.$t('jobs.filter.allOption')
				},
				...this.brands.map(b => ({
					value: b,
					label: b
				}))
			]
		},
		cantonOptions() {
			return [
				{
					value: '',
					label: this.$t('jobs.filter.allOption')
				},
				...this.cantons.map(c => ({
					value: c,
					label: this.$te(`jobs.cantons.${c}`) ? this.$t(`jobs.cantons.${c}`) : c,
				}))
			]
		},
		workAreaOptions() {
			return [
				{
					value: '',
					label: this.$t('jobs.filter.allOption')
				},
				...this.workAreas.map(a => ({
					value: a.id,
					label: a.name
				}))
			]
		},
		filteredJobs() {
			return this.jobs
				.filter(job => {
					let hide = false

					if (this.filters.brand && job.brand !== this.filters.brand) {
						hide = true
					}

					if (this.filters.canton && job.canton !== this.filters.canton) {
						hide = true
					}

					if (this.filters.region && job.region !== this.filters.region) {
						hide = true
					}

					if (this.filters.workArea !== '' && !job.workAreas.find(a => a.id === +this.filters.workArea)) {
						hide = true
					}

					return !hide
				})
				.map(job => ({
					...job,
					title: job.title,
					subtitle: [job.brand, job.location || job.region || (this.$te(`jobs.cantons.${job.canton}`) ? this.$t(`jobs.cantons.${job.canton}`) : job.canton)].join(', '),
					brandKey: this.getBrandKey(job.brand),
				}))
		}
	},
	methods: {
		getBrandKey(brand) {
			brand = brand.toLowerCase()

			if (brand.includes('butcher')) {
				return 'butcher'
			}
			if (brand.includes('republic')) {
				return 'kitchenrepublic'
			}
			if (brand.includes('miu')) {
				return 'missmiu'
			}
			if (brand.includes('negishi')) {
				return 'negishi'
			}
			if (brand.includes('nooch')) {
				return 'nooch'
			}
			if (brand.includes('outback')) {
				return 'outbacklodge'
			}
			if (brand.includes('fwg')) {
				return 'fwg'
			}
		}
	},
	async mounted() {
		this.loading = true;
		await this.$store.dispatch('jobs/loadJobs')
		this.loading = false;
	}
}
</script>
